import { useContext } from "react"
import { ProgramContext } from "context/ProgramContext"

// import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid"

/*
const NANO_VOLUME_WORKOUT_SLOT_CONFIG_FIELDS = [
    { key: 'bilateralReps', label: 'Reps' },
    { key: 'unilateralReps', label: 'Reps/side' },
    { key: 'plyometricOverrideUnilateralReps', label: 'Plyometric Override Unilateral Reps' },
    { key: 'plyometricOverrideBilateralReps', label: 'Plyometric Override Bilateral Reps' },
    { key: 'bilateralSeconds', label: ' Seconds' },
    { key: 'unilateralSeconds', label: 'Unilateral Seconds' },
]
*/

export default function NanoVolumeWorkoutSlotConfigEditor({ 
    microVolumeConfigIndex,
    workoutConfigIndex,
    workoutPhaseIndex,
    workoutSlotIndex,
    workoutSlotConfig
}) {

    const { MesoVolumeConfigSubContextData, NanoVolumeWorkoutSlotConfigSubContextData } = useContext(ProgramContext)
    const { mesoVolumeConfigDraft } = MesoVolumeConfigSubContextData
    const { HandleNanoVolumeWorkoutSlotConfigDraftChange } = NanoVolumeWorkoutSlotConfigSubContextData

    // const [expanded, setExpanded] = useState(false)

    /*
    const workoutSlotConfig = mesoVolumeConfigDraft
        ?.microVolumes?.[microVolumeConfigIndex]
        ?.workoutConfigs?.[workoutConfigIndex]
        ?.workoutPhaseConfigs?.[workoutPhaseIndex]
        ?.workoutSlotConfigs?.[workoutSlotIndex] ?? {}
    */

    return (
        <div className='border-t border-gray-300 space-y-2'>
            <div className="flex items-center">
                <div>
                    <p className='w-8 text-sm text-center text-gray-500 flex-grow select-none border-r border-gray-300'>
                        {workoutSlotIndex + 1}
                    </p>
                </div>

                <div className="pl-3 flex items-center justify-center border-r border-gray-300">
                    <p className="text-sm text-gray-500">
                        Reps/side:
                    </p>

                    <input
                        type="number"
                        className="w-10 pl-2 text-sm font-bold placeholder:text-gray-900 placeholder:font-bold [&::-webkit-inner-spin-button]:block [&::-webkit-inner-spin-button]:opacity-100"
                        placeholder="1"
                        min={1}
                        value={workoutSlotConfig.unilateralReps ?? 1}
                        onChange={(event) => HandleNanoVolumeWorkoutSlotConfigDraftChange(
                            microVolumeConfigIndex,
                            workoutConfigIndex,
                            workoutPhaseIndex,
                            workoutSlotIndex,
                            'unilateralReps',
                            event.target.value === '' ? '' : parseInt(event.target.value, 10)
                        )}
                    />
                </div>

                <div className="pl-3 flex-1 flex items-center justify-center border-r border-gray-300">
                    <p className="text-sm text-gray-500">
                        Reps:
                    </p>

                    <input
                        type="number"
                        className="w-10 pl-2 text-sm font-bold placeholder:text-gray-900 placeholder:font-bold [&::-webkit-inner-spin-button]:block [&::-webkit-inner-spin-button]:opacity-100"
                        placeholder="1"
                        min={1}
                        value={workoutSlotConfig.bilateralReps ?? 1}
                        onChange={(event) => HandleNanoVolumeWorkoutSlotConfigDraftChange(
                            microVolumeConfigIndex,
                            workoutConfigIndex,
                            workoutPhaseIndex,
                            workoutSlotIndex,
                            'bilateralReps',
                            event.target.value === '' ? '' : parseInt(event.target.value, 10)
                        )}
                    />
                </div>

                {/* 
                <div 
                    className="flex-1 flex items-center justify-center cursor-pointer"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded && <ChevronUpIcon className='w-4 h-4 text-gray-600' />} 
                    {!expanded && <ChevronDownIcon className='w-4 h-4 text-gray-600' />}
                </div> 
                */}
            </div>

            {/* 
            {expanded && (
                <div className="space-y-2">
                    {NANO_VOLUME_WORKOUT_SLOT_CONFIG_FIELDS.map(({ key, label }) => (
                        <div 
                            key={key} 
                            className="flex items-center gap-x-4"
                        >
                            <p className='text-sm text-left flex-grow select-none'>
                                {label}
                            </p>

                            <input
                                type="number"
                                className="w-14 border border-gray-300 rounded-md text-center"
                                placeholder="1"
                                min={1}
                                value={workoutSlotConfig[key] ?? ''}
                                onChange={(event) => HandleNanoVolumeWorkoutSlotConfigDraftChange(
                                    microVolumeConfigIndex,
                                    workoutConfigIndex,
                                    workoutPhaseIndex,
                                    workoutSlotIndex,
                                    key,
                                    event.target.value === '' ? '' : parseInt(event.target.value, 10)
                                )}
                            />
                        </div>
                    ))}
                </div>
            )} 
            */}
        </div>
    )
}
